<div class="company-bank-account-verification">
    <div class="form-group">
      <label for="email_address" class="fw-bold text-xs">Email Address</label>
      <input type="email" v-model="form.email_address" id="email_address" class="form-control text-xs rounded-small p-3 shadow-sm" required />
      <small v-if="error_messages.email_address" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.email_address }}
      </small>
    </div>
    <div class="form-group">
      <label for="company_name" class="fw-bold text-xs">Company Name</label>
      <input type="text" v-model="form.company_name" id="company_name" class="form-control text-xs rounded-small p-3 shadow-sm" required />
      <small v-if="error_messages.company_name" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.company_name }}
      </small>
    </div>
    <div class="form-group">
      <label for="company_registration" class="fw-bold text-xs">Company Registration No.</label>
      <input type="text" v-model="form.company_registration" id="company_registration" class="form-control text-xs rounded-small p-3 shadow-sm" @input="validate_reg_number" required />
      <small v-if="error_messages.company_registration" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.company_registration }}
      </small>
    </div>
    <div class="form-group">
      <label for="bank_name" class="fw-bold text-xs">Bank Name</label>
      <select v-model="form.bank_name" id="bank_name" class="form-select text-xs rounded-small p-3 shadow-sm" required>
        <option value="" disabled hidden>Select Bank</option>
        <option v-for="bank in banks" :key="bank.id" :value="bank.name">
          {{ bank.name }}
        </option>
      </select>
      <small v-if="error_messages.bank_name" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.bank_name }}
      </small>
    </div>
    <div class="form-group">
      <label for="branch_code" class="fw-bold text-xs">Branch Code</label>
      <input type="text" v-model="form.branch_code" id="branch_code" class="form-control text-xs rounded-small p-3 shadow-sm" required />
      <small v-if="error_messages.branch_code" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.branch_code }}
      </small>
    </div>
    <div class="form-group">
      <label for="account_type" class="fw-bold text-xs">Account Type</label>
      <select v-model="form.account_type" id="account_type" class="form-select text-xs rounded-small p-3 shadow-sm" required>
        <option value="" disabled hidden>Select Account Type</option>
        <option v-for="account_type in account_types" :key="account_type.id" :value="account_type.name">
          {{ account_type.name }}
        </option>
      </select>
      <small v-if="error_messages.account_type" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.account_type }}
      </small>
    </div>
    <div class="form-group">
      <label for="bank_account" class="fw-bold text-xs">Account Number</label>
      <input type="text" v-model="form.bank_account" id="bank_account" class="form-control text-xs rounded-small p-3 shadow-sm" required />
      <small v-if="error_messages.bank_account" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.bank_account }}
      </small>
    </div>
    <div class="d-flex justify-content-end my-2">
        <button @click="handle_submit" class="btn btn-primary-color rounded-pill text-xs">
            Run Service
        </button>
    </div>
</div>
